import React from 'react';
import { Button, Dropdown } from 'antd';
import { ChevronDown } from 'lucide-react';
import {
  PromptTarget,
  TaskPromptContext
} from '../../../../../utils/taskPrompt';
import useTaskPrompt from './useTaskPrompt';
import { getLangKey } from '../../../../../models/Language';
import * as translations from './strings';
import styles from './styles.module.css';

const strings = translations[getLangKey()];
const openInTargets: { key: PromptTarget; label: string }[] = [
  { key: 'cursor', label: strings.cursor },
  { key: 'claude', label: strings.claudeCode },
  { key: 'codex', label: strings.codex },
  { key: 'vscode', label: strings.vsCode }
];

export default function TaskPrompt({
  context,
  container
}: {
  context?: TaskPromptContext;
  container: HTMLDivElement;
}) {
  const { copyPrompt, openIn, dialog } = useTaskPrompt(context, container);
  if (!context) return null;
  const shortcut = /Mac|iPhone|iPad/.test(navigator.platform)
    ? '⌘⇧P'
    : 'Ctrl+Shift+P';

  return (
    <>
      {dialog}
      <Dropdown
        trigger={['click']}
        placement="bottomRight"
        getPopupContainer={() => container || document.body}
        menu={{
          items: [
            {
              key: 'copy',
              label: (
                <span className={styles.copyLabel}>
                  {strings.copyPrompt}
                  <span className={styles.shortcut}>{shortcut}</span>
                </span>
              ),
              onClick: copyPrompt
            },
            { type: 'divider' },
            {
              type: 'group',
              label: <span className={styles.openIn}>{strings.openIn}</span>,
              children: openInTargets.map(target => ({
                key: target.key,
                label: <span className={styles.option}>{target.label}</span>,
                onClick: () => openIn(target.key)
              }))
            }
          ]
        }}
      >
        <Button type="text" size="small" className={styles.trigger}>
          {strings.copyPrompt}
          <ChevronDown size={10} />
        </Button>
      </Dropdown>
    </>
  );
}
